import { m } from 'framer-motion';

import { MenuItem } from './MenuItem';
import NavMobileItem from './NavMobileItem';
import styles from './styles.module.css';

import type { NavConfig } from '../../../../routes';

const variantsUl = {
  open: {
    display: 'flex',
    transition: { staggerChildren: 0.07, delayChildren: 0.5 }
  },
  closed: {
    display: 'none',
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

const variantsLi = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

interface NavigationProps {
  navConfig: NavConfig;
}

export const Navigation: React.FC<NavigationProps> = ( { navConfig } ) => (
  <m.ul variants={variantsUl}>
    {navConfig.map( (link) => (
      <MenuItem
        key={link.title}
        sx={{
          listStyle: 'none',
          width: '100%',
          padding: 0,
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        variants={variantsLi}
        whileTap={{ scale: 0.95 }}
      >
        <NavMobileItem
          item={link as any}
          activeItem={(
            (): JSX.Element => <m.span
              className={styles.activeItem}
              initial={{
                x: 0
              }}
              animate={{
                x: '100%'
              }}
              transition={{
                delay: 0.75,
                duration: 0.5
              }}/>
          ) as React.FC}/>
      </MenuItem>
    ) )}
  </m.ul>
);
